import React from 'react';


const facts = [
  {
    value: 99,
    text: 'Happy customer',
    delay: '.1s',
  },
  {
    value: 25,
    text: 'Thousands of successful business',
    delay: '.3s',
  },
  {
    value: 120,
    text: 'Total clients who love Aesos',
    delay: '.5s',
  },
  {
    value: 5,
    text: 'Stars reviews given by satisfied clients',
    delay: '.7s',
  },
];

const Fact = () => {
  return (
    <div className="container-fluid bg-secondary py-5">
      <div className="container">
        <div className="row">
          {facts.map((fact, index) => (
            <div className="col-lg-3 wow fadeIn" data-wow-delay={fact.delay} key={index}>
              <div className="d-flex counter">
                <h1 className="me-3 text-primary counter-value">{fact.value}</h1>
                <h5 className="text-white mt-1">{fact.text}</h5>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Fact;
